import urlJoin from 'url-join';
import {TreatmentPackage} from './AppEnums';

export const initialUrl = '/'; // this url will open after login
export const AUTH_TOKEN: string = 'app-auth-token';
export const TOKEN: string = 'app-token';
export const REFRESH_TOKEN: string = 'app-refresh-token';
export const MAX_AGE = 60 * 60 * 24 * 1;
export const Default_Language: string = 'app-language';
export const User_Status: string = 'user-status';
export const FCM_TOKEN_KEY = 'fcm-token';
export const LANGUAGE_HEADER_KEY = 'language-key';
export const PERMISSIONS_KEY = 'permissions';

export const PrimaryColor = '#EA5383';
export const SidebarColor = '#fff';
export const UPLOAD_ICON_VALIDATE = [
  'image/svg+xml',
  'image/vnd.microsoft.icon',
  'image/gif',
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/bmp',
  'image/webp',
];

export const formatDateTime: string = 'YYYY-MM-DD hh:mm A';
export const formatDateWithSecondsTime: string = 'YYYY-MM-DD hh:mm:ss A';
export const formatDate: string = 'YYYY/M/DD';
export const formatTimeWithMonthAndDay: string = 'MMM DD hh:mm a';
export const formatTime: string = 'hh:mm a';

export const passwordRegex: any =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,}$/;

export const emailRegex: any =
  /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

export const countryCodeDefault = '+961';

export const remoteServiceBaseUrl = process.env.REACT_APP_PUBLIC_BASE;

export const remoteServiceBaseApiUrl = urlJoin(
  `${process.env.REACT_APP_PUBLIC_BASE}`,
);

export const remoteSocketIoUrl = process.env.REACT_APP_REMOTE_SOCKETIO_BASE_URL;

export const PRODUCT_NUMBER_IN_ONE_PAGE = 10;
export const PAGE_NUMBER = 1;

export const apiKeyGoogleMap =
  'AIzaSyC_MPgcB-GAIUYap_caF_lQdB1UqFIEhMg&callback=initMap&v=weekly';

export const INDEX_PAGE_SIZE_DEFAULT = 10;
export const INDEX_PAGE_SIZE_OPTIONS = ['10', '20', '30', '40'];

export const UPLOAD_PICTURE_VALIDATE = [
  'image/gif',
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/bmp',
  'image/webp',
];
export const UPLOAD_FILE_VALIDATE = ['text/plain', 'application/pdf'];

export const CUSTOMER_ROLES = {
  Administrators: 'Administrators',
};

export const FilterOperators = {
  Equals: '==',
  NotEquals: '!=',
  Contains: '@=',
  StringContains: '@=*',
};
export const GENDER_TYPE = [
  {
    value: 1,
    label: 'common.male',
  },
  {
    value: 2,
    label: 'common.female',
  },
];

export const UserStatus = {Pending: 1, InActive: 2, Active: 3, Archived: 4};

export const UserType = {
  Admin: 1,
  Doctor: 2,
  Coordinator: 3,
  Laboratory: 4,
  Fabricator: 5,
  Planner: 6,
  AgentCompany: 7,
};

export const UserTypeArray = [
  {
    value: 1,
    label: 'common.admin',
  },
  {
    value: 3,
    label: 'common.coordinator',
  },
  {value: 5, label: 'common.fabricator'},
  {value: 6, label: 'common.planner'},
  {value: 7, label: 'common.agentCompany'},
];

export const TreatmentStatusArray = [
  {
    value: 0,
    label: 'common.pending',
  },
  {
    value: 1,
    label: 'common.prescription',
  },
  {value: 2, label: 'common.imperssion'},
];

export const TreatmentTypeArray = [
  {
    value: 1,
    label: 'common.aligner',
  },
  {
    value: 2,
    label: 'common.whitening',
  },
  {
    value: 3,
    label: 'common.retainers',
  },
];

export const TreatmentSteps = {
  TreatmentType: 'treatmentType',
  Prescription: 'prescription',
  Impressions: 'impressions',
  Photos: 'photos',
  Xrays: 'xrays',
  Shipping: 'shipping',
  Discount: 'discount',
  Summery: 'summery',
};

export const CaseSteps = {
  CaseType: 'treatmentType',
  Prescription: 'prescription',
  Impressions: 'impressions',
  Optional: 'optional',
  Notes: 'notes',
  Shipping: 'shipping',
  Summery: 'summery',
};

export const ToothList = {
  UpperRight1: '1.1',
  UpperRight2: '1.2',
  UpperRight3: '1.3',
  UpperRight4: '1.4',
  UpperRight5: '1.5',
  UpperRight6: '1.6',
  UpperRight7: '1.7',
  UpperRight8: '1.8',
  UpperLeft1: '2.1',
  UpperLeft2: '2.2',
  UpperLeft3: '2.3',
  UpperLeft4: '2.4',
  UpperLeft5: '2.5',
  UpperLeft6: '2.6',
  UpperLeft7: '2.7',
  UpperLeft8: '2.8',
  LowerRight1: '4.1',
  LowerRight2: '4.2',
  LowerRight3: '4.3',
  LowerRight4: '4.4',
  LowerRight5: '4.5',
  LowerRight6: '4.6',
  LowerRight7: '4.7',
  LowerRight8: '4.8',
  LowerLeft1: '3.1',
  LowerLeft2: '3.2',
  LowerLeft3: '3.3',
  LowerLeft4: '3.4',
  LowerLeft5: '3.5',
  LowerLeft6: '3.6',
  LowerLeft7: '3.7',
  LowerLeft8: '3.8',
};

export const TreatmentOrderStatus = {
  draft: 1,
  submitted: 2,
  assigned: 3,
  pending: 4,
  auditing: 5,
  approved: 6,
  ready: 7,
  shipped: 8,
  revision: 9,
  revised: 10,
  completed: 11,
  readyForShipping: 12,
  shippingRequested: 13,
  pendingModification: 14,
  modificationCompleted: 15,
  pendingAgentApproval: 16
};

export const CaseOrderStatus = {
  draft: 1,
  submitted: 2,
  auditing: 3,
  ready: 4,
  shipped: 5,
  revision: 6,
  completed: 7,
  readyForShipping: 8,
  shippingRequested: 9,
};

export const TreatmentPackageString = [
  {
    value: TreatmentPackage.AsYouGo,
    label: 'common.asYouGo',
  },
  {
    value: TreatmentPackage.EcoPlan,
    label: 'common.ecoPlan',
  },
  {
    value: TreatmentPackage.Ultimate,
    label: 'common.ultimate',
  },
  {
    value: TreatmentPackage.Retainer,
    label: 'common.retainer',
  },
  {
    value: TreatmentPackage.WhiteningTube,
    label: 'common.whiteningTube',
  },
  {
    value: TreatmentPackage.WhiteningMold,
    label: 'common.whiteningMold',
  },
];

export const CaseTypeInPricing = {
  design: 1,
  fabrication: 2,
};

export const CaseType = {
  fabrication: 1,
  design: 2,
};
export const PromoCodeType = {
  percentage: 1,
  fixedAmount: 2,
  freeOrder: 3,
  freeDelivery: 4,
};

export const DiscountAmountType = {
  percentage: 1,
  fixedAmount: 2,
};
